interface HistoryAppointment {
  id: string;
  customerId: string;
  startsAt: string;
}

interface HistoryConversation {
  id: string;
  customerId: string | null;
  callerPhoneNumber: string;
  startedAt: string;
}

export type CustomerHistoryItem<
  A extends HistoryAppointment,
  C extends HistoryConversation,
> =
  | { type: "appointment"; at: string; appointment: A }
  | { type: "call"; at: string; call: C };

export function buildCustomerHistory<
  A extends HistoryAppointment,
  C extends HistoryConversation,
>(input: {
  customerId: string;
  phoneNumber: string;
  appointments: A[];
  conversations: C[];
}): Array<CustomerHistoryItem<A, C>> {
  return [
    ...input.appointments
      .filter((item) => item.customerId === input.customerId)
      .map((appointment) => ({
        type: "appointment" as const,
        at: appointment.startsAt,
        appointment,
      })),
    ...input.conversations
      .filter(
        (item) =>
          item.customerId === input.customerId ||
          item.callerPhoneNumber === input.phoneNumber,
      )
      .map((call) => ({ type: "call" as const, at: call.startedAt, call })),
  ].sort((left, right) => right.at.localeCompare(left.at));
}
